import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate, formatPhoneNumber} from "page/util/helpers";

export default function Main() {

    const [contents, setContents] = useState([]);

    const navigate = useNavigate();

    const requestSearch = (e) => {
        axios.get(`/admin/push/triggers`)
            .then((res) => {
                setContents(res.data);
            });
    }

    const displayTriggerType = (triggerType) => {
        switch (triggerType) {
            case "MEMBERSHIP_GUIDE_VIEW": return "멤버십 이용안내 진입";
            case "EMPLOYMENT_CONTRACT_VIEW": return "근로계약서 진입";
            case "CHANNEL_TALK_VIEW": return "채널톡 진입";
            case "SALARY_CALCULATOR_VIEW": return "급여 계산하기 진입";
            case "INSURANCE_CALCULATOR_VIEW": return "4대보험 계산하기 진입";
            default: return "";
        }
    }

    useEffect(() => {
        requestSearch();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">푸시메시지 - 행동기반 설정</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>

                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '0px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>행동타입</th>
                                                    <th style={{width: "50%"}}>제목</th>
                                                    <th>사용여부</th>
                                                    <th>진입횟수</th>
                                                    <th>딜레이 시간(h)</th>
                                                    <th>수정일</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{displayTriggerType(item.behaviorType)}</td>
                                                                <td>{item.title}</td>
                                                                <td>
                                                                    {
                                                                        item.enabled ?
                                                                        <span style={{color: "blue"}}>사용중</span>
                                                                        :
                                                                        <span style={{color: "darkgray"}}>미사용</span>
                                                                    }
                                                                </td>
                                                                <td>{item.triggerCount}</td>
                                                                <td>{item.delayHour}</td>
                                                                <td>{formatDate(item.updatedAt)}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={ () => { navigate(`/page/push/trigger/detail?id=${item.id}`) }}>
                                                                        보기
                                                                    </button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
}


